var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather02D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-02d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-02d",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    stroke: "#E3B505"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#F5D547",
    strokeLinecap: "square",
    cx: 30,
    cy: 29,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7504752,0.501273783 L27.7504752,8.52165431 M36.6855938,1.91505595 L34.0744133,9.49847473 M44.6788546,6.16558991 L39.7410153,12.485736 M50.8633454,12.7919303 L44.1368883,17.1601426 M54.5683102,21.0754605 L46.7861693,23.0157662 M55.3918981,30.1178261 L47.4020376,29.4188039 M53.2447496,38.938362 L45.9177674,35.6761794 M48.3596917,46.5804484 L42.4939567,41.1105621 M41.2664918,52.2152602 L37.5011512,45.1336845 M32.7344055,55.2316577 L31.4797416,47.3100213 M23.7585,55.3097262 L25.0131639,47.3880899 M15.1741428,52.4495498 L18.9394834,45.3679741 M7.9806593,46.9454302 L13.8463943,41.4755439 M2.9582322,39.3942665 L10.2852144,36.1320839 M0.651596908,30.6149767 L8.64145747,29.9159545 M1.31095875,21.5596863 L9.0930997,23.4999919 M4.86485266,13.2104685 L11.5913098,17.5786808 M10.9278889,6.47283553 L15.8657282,12.7929816 M18.8425455,2.07753062 L21.453726,9.66094939",
    id: "Line",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.1700534,24.1226303 C49.4231553,24.6740486 48.4996426,25 47.5,25 C46.2956855,25 45.2018669,24.5269107 44.3942493,23.7564372 C43.615266,25.0979396 42.1629768,26 40.5,26 C39.1731421,26 37.9804108,25.4257353 37.15679,24.5121896 C36.5037866,24.8248836 35.7723436,25 35,25 C32.2385763,25 30,22.7614237 30,20 C30,17.4983439 31.8372192,15.4257934 34.2360056,15.0580006 C34.8370864,13.279981 36.5190654,12 38.5,12 C39.221027,12 39.9024472,12.1695767 40.5065539,12.4710235 C41.7886023,10.9658238 43.7728349,10 46,10 C49.311324,10 52.0856357,12.1349928 52.8135557,15.0034118 C52.8754234,15.0011439 52.9375781,15 53,15 C55.7614237,15 58,17.2385763 58,20 C58,22.7614237 55.7614237,25 53,25 C51.9495424,25 50.9747448,24.6760613 50.1700534,24.1226303 Z",
    id: "Combined-Shape-Copy-4",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6790513,49.222444 C24.9046563,49.7148086 23.9856331,50 23,50 C21.5692923,50 20.278934,49.3990925 19.3675427,48.435895 C18.5125118,49.9656793 16.8770452,51 15,51 C13.657223,51 12.438074,50.4706858 11.539823,49.6093274 C10.9090667,49.8613726 10.2207224,50 9.5,50 C6.46243388,50 4,47.5375661 4,44.5 C4,41.8509085 5.87286728,39.6392487 8.36674418,39.116878 C9.11049379,37.2887876 10.9047407,36 13,36 C13.9405871,36 14.8205136,36.2597191 15.5719768,36.7113546 C16.9440386,35.0616459 19.0891832,34 21.5,34 C24.8987892,34 27.7695393,36.1100841 28.6904465,39.0032355 C31.6398268,39.1035982 34,41.5261751 34,44.5 C34,47.5375661 31.5375661,50 28.5,50 C27.4687842,50 26.5038535,49.7162001 25.6790513,49.222444 Z",
    id: "Combined-Shape-Copy-5",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather02D);
export default __webpack_public_path__ + "static/media/icon-weather-02d.8a5ece882ce4ab67700d8dcfea8daefe.svg";
export { ForwardRef as ReactComponent };